<template>
  <section>
    <!--工具条-->
    <toolbar
      placeholder="请输入标题"
      :buttonList="buttonList"
      @callFunction="callFunction"
    ></toolbar>

    <!--列表-->
    <el-table
      :data="itemList"
      v-loading="listLoading"
      highlight-current-row
      style="width: 100%"
      ref="table"
      @select="dialogCheck"
      @row-click="selectCurrentRow"
      class="custom-tbl"
    >
      <el-table-column type="selection" min-width="20"> </el-table-column>
      <el-table-column type="index" label="序号" min-width="20">
      </el-table-column>
      <el-table-column prop="coverImage" label="封面" min-width="50">
        <template slot-scope="scope">
          <el-avatar
            shape="square"
            v-if="scope.row.coverImage"
            :src="scope.row.coverImage.url"
          ></el-avatar>
        </template>
      </el-table-column>
      <el-table-column
        prop="title"
        label="标题"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="description"
        label="简介"
        min-width="150"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="isDisable"
        label="状态"
        min-width="50"
        show-overflow-tooltip
        sortable
      >
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.isDisable ? 'danger' : 'success'"
            disable-transitions
            >{{ scope.row.isDisable ? "停用" : "正常" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="200">
        <template slot-scope="scope">
          <el-button
            v-if="!scope.row.isDisable"
            size="small"
            plain
            round
            type="danger"
            @click="handleDisable(scope.row)"
            >停用</el-button
          >
          <el-button
            v-if="scope.row.isDisable"
            size="small"
            plain
            round
            type="primary"
            @click="handleEnable(scope.row)"
            >启用</el-button
          >
          <el-button
            size="mini"
            plain
            round
            type="primary"
            @click="handleEditScreenConfig(scope.row)"
            >排片编辑</el-button
          >
          <el-button
            size="mini"
            plain
            round
            type="primary"
            @click="handlePreviewScreenConfig(scope.row)"
            >排片预览</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageModel.page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageModel.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageModel.dataCount"
        style="float:right;"
      >
      </el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="100px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="标题" prop="title">
              <el-input v-model="editForm.title" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否停用" prop="isDisable">
              <el-switch v-model="editForm.isDisable"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="场馆简介" prop="description">
              <el-input
                v-model="editForm.description"
                auto-complete="off"
                type="textarea"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="封面上传" prop="coverImage">
              <ImageFile
                tips="推荐尺寸16:9,大小不超过1MB"
                :value="coverImageList"
                :limitCount="1"
                :limitSize="1024"
                @change="coverImageChange"
              ></ImageFile>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="颜色" prop="mainColor">
              <el-select
                v-model="editForm.mainColor"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option v-for="item in predefineMainColors" :key="item.key" :label="item.value.name" :value="item.key">
                  <span style="text-align:center;display:block;width:100%;color:white;" :style="{backgroundColor: item.value.bgColor}">{{ item.value.name }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="图片上传" prop="contentImage">
              <ImageFile
                tips="推荐尺寸16:9,大小不超过1MB"
                :value="contentImageList"
                :limitCount="3"
                :limitSize="1024"
                @change="contentImageChange"
                :isMultiple="true"
              ></ImageFile>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input
                v-model="editForm.remark"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="100px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="标题" prop="title">
              <el-input v-model="addForm.title" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否停用" prop="isDisable">
              <el-switch v-model="addForm.isDisable"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="简介" prop="description">
              <el-input
                v-model="addForm.description"
                auto-complete="off"
                type="textarea"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="封面上传" prop="coverImage">
              <ImageFile
                tips="推荐尺寸16:9,大小不超过1MB"
                :value="coverImageList"
                :limitCount="1"
                :limitSize="1024"
                @change="coverImageChange"
              ></ImageFile>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="颜色" prop="mainColor">
              <el-select
                v-model="addForm.mainColor"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option v-for="item in predefineMainColors" :key="item.key" :label="item.value.name" :value="item.key">
                  <span style="text-align:center;display:block;width:100%;color:white;" :style="{backgroundColor: item.value.bgColor}">{{ item.value.name }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="图片上传" prop="contentImage">
              <ImageFile
                tips="推荐尺寸16:9,大小不超过1MB"
                :value="contentImageList"
                :limitCount="4"
                :limitSize="1024"
                @change="contentImageChange"
                :isMultiple="true"
              ></ImageFile>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input
                v-model="addForm.remark"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--排片编辑-->
    <el-drawer
      title="排片编辑"
      size="870px"
      :visible.sync="editRoomScreenConfigFormVisible"
      direction="rtl"
      :before-close="handleRoomScreenConfigClose"
    >
      <el-form
        :model="editRoomScreenConfigForm"
        label-width="80px"
        :rules="editRoomScreenConfigFormRules"
        ref="editRoomScreenConfigForm"
      >
        <el-row>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="10">
            <el-form-item label="展示列数" prop="columns">
              <el-input
                type="number"
                v-model.number="editRoomScreenConfigForm.columns"
                :min="1"
                :max="8"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="10">
            <el-form-item label="展示行数" prop="rows">
              <el-input
                type="number"
                v-model.number="editRoomScreenConfigForm.rows"
                :min="1"
                :max="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div style="width: 100%" @paste="handlePaste($event)">
          <el-row>
            <el-col :span="24">
              <el-table
                ref="roomScreenConfigTable"
                class="roomScreenConfigTable"
                style="width:870px;max-width:870px;"
                :data="roomScreenConfigTable"
                :border="true"
                :cell-style="{ padding: '2px' }"
                :header-cell-style="{
                  textAlign: 'center',
                  background: '#f3f3f3',
                }"
              >
                <el-table-column
                  v-for="index of editRoomScreenConfigForm.columns"
                  :key="index"
                  :prop="'col' + (index - 1)"
                  :label="'列' + index"
                  :min-width="roomScreenConfigTableWidth[index - 1]"
                >
                  <template slot-scope="scope">
                    <el-input
                      style="width: 100%"
                      :name="'col' + (index - 1)"
                      v-model="scope.row['col' + (index - 1)]"
                      @input="handleColInput(scope.$index, index - 1, $event)"
                    ></el-input>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" style="height: 30px">&nbsp;</el-col>
          </el-row>
          <el-row>
            <el-col :span="6">&nbsp;</el-col>
            <el-col :span="6">
              <el-button
                style="width: 50%"
                type="danger"
                size="normal"
                @click="cancelEditRoomScreenConfigForm"
                >取消</el-button
              >
            </el-col>
            <el-col :span="6">
              <el-button
                style="width: 50%"
                type="primary"
                size="normal"
                @click="saveEditRoomScreenConfigForm"
                >保存</el-button
              >
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-drawer>
  </section>
</template>

<script>
import util from "../../../util/date";
import {
  queryRoomScreenListPage,
  removeRoomScreen,
  saveRoomScreen,
  disableRoomScreen,
  saveRoomScreenConfig
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import ImageFile from "../../components/ImageFile";
import { ScreenColorTheme } from "../../api/enum";

export default {
  components: { Toolbar, ImageFile },
  data() {
    return {
      buttonList: [],
      currentRow: null,
      filter: {
        key: "",
        page: 1,
        pageSize: 10,
      },
      itemList: [],
      pageModel: {
        pageSize: 10,
        dataCount: 0,
        page: 1,
        pageCount: 0,
      },
      listLoading: false,
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        title: [
          { required: true, message: "请输入标题", trigger: "blur" },
          {
            min: 2,
            max: 100,
            message: "标题长度在2到100个字符",
            trigger: "blur",
          },
        ],
        description: [
          {
            max: 500,
            message: "简介长度不能超过500个字符",
            trigger: "blur",
          },
        ],
        remark: [
          {
            max: 100,
            message: "备注长度不能超过100个字符",
            trigger: "blur",
          },
        ],
        isDisable: [
          { required: true, message: "请选择是否停用", trigger: "blur" },
        ],
      },
      //编辑界面数据
      editForm: {
        id: "",
        title: "",
        description: "",
        remark: "",
        isDisable: false,
      },
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        title: [
          { required: true, message: "请输入标题", trigger: "blur" },
          {
            min: 2,
            max: 100,
            message: "标题长度在2到100个字符",
            trigger: "blur",
          },
        ],
        description: [
          {
            max: 500,
            message: "简介长度不能超过500个字符",
            trigger: "blur",
          },
        ],
        remark: [
          {
            max: 100,
            message: "备注长度不能超过100个字符",
            trigger: "blur",
          },
        ],
        isDisable: [
          { required: true, message: "请选择是否停用", trigger: "blur" },
        ],
      },
      //新增界面数据
      addForm: {
        title: "",
        description: "",
        remark: "",
        isDisable: false,
      },
      coverImageList: [],
      contentImageList: [],
      editRoomScreenConfigFormVisible: false,
      roomScreenConfigTable: [],
      roomScreenConfigTableWidth: [],
      editRoomScreenConfigForm: {
        columns: 4,
        rows: 4,
      },
      editRoomScreenConfigFormRules: {
        columns: [
          { required: true, message: "请输入展示列数", trigger: "blur" },
        ],
        rows: [{ required: true, message: "请输入展示行数", trigger: "blur" }],
      },
      predefineMainColors: []
    };
  },
  methods: {
    coverImageChange() {},
    contentImageChange() {},
    handleSizeChange(val) {
      this.filter.page = 1;
      this.filter.pageSize = val;
      this.handleQuery();
    },
    handleCurrentChange(val) {
      this.filter.page = val;
      this.handleQuery();
    },
    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      this.filter.key = item.search;
      this[item.func].apply(this, item);
    },
    handleEditScreenConfig(row) {
      this.currentRow = row;
      if (row.roomScreenConfig && row.roomScreenConfig.extensionData) {
        this.editRoomScreenConfigForm = row.roomScreenConfig;
        var extensionData = JSON.parse(row.roomScreenConfig.extensionData);
        this.roomScreenConfigTable = extensionData.dataConfigs || [];
        this.roomScreenConfigTableWidth =
          extensionData.columnWidthConfigs || [];
      }
      this.editRoomScreenConfigFormVisible = true;
    },
    handleColInput(row, column, event) {
      let content = event.toString();
      if (content.indexOf("\t") < 0) {
        this.roomScreenConfigTable[row]["col" + column] = event;
        this.$forceUpdate();
      }
    },
    cancelEditRoomScreenConfigForm() {
      this.roomScreenConfigTable = [];
      this.handleRoomScreenConfigClose();
    },
    saveEditRoomScreenConfigForm() {
      this.$confirm("确定保存屏幕配置吗？")
        .then((_) => {
          let configTable = this.$refs["roomScreenConfigTable"];
          let extensionData = {
            columnWidthConfigs: configTable.columns.map((x) =>
              parseInt(x.width || x.realWidth)
            ),
            dataConfigs: this.roomScreenConfigTable,
          };
          let param = {
            screenId: this.currentRow.id,
            columns: this.editRoomScreenConfigForm.columns,
            rows: this.editRoomScreenConfigForm.rows,
            isDisable: false,
            extensionData: JSON.stringify(extensionData),
          };
          saveRoomScreenConfig(param).then((res) => {
            if (res.data.isSuccess) {
              this.$message({
                message: "配置成功",
                type: "success",
              });
              this.editRoomScreenConfigFormVisible = false;
              this.handleQuery();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        })
        .catch((_) => {});
    },
    handlePreviewScreenConfig(row) {
      window.open("/#/RoomScreenDetail?id=" + row.id);
    },
    handleHistoryScreenConfig(row) {},
    handlePaste(event) {
      let _this = this;
      let text = event.clipboardData.getData("text/plain");
      const rows = text.trim().split("\r\n");
      if (rows.length == 0 || (rows.length >= 1 && rows[0].indexOf("\t") < 0)) {
        return true;
      }
      for (let r = 0; r < _this.editRoomScreenConfigForm.rows; r++) {
        if (rows.length > r && rows[r].length > 0) {
          var rowData = {};
          var columns = rows[r].split("\t");
          for (let c = 0; c < _this.editRoomScreenConfigForm.columns; c++) {
            if (columns.length > c) {
              rowData["col" + c] = columns[c];
            }
          }
          _this.roomScreenConfigTable[r] = rowData;
        }
      }
    },
    handleRoomScreenConfigClose() {
      this.$confirm("取消排片编辑？")
        .then((_) => {
          this.editRoomScreenConfigFormVisible = false;
        })
        .catch((_) => {});
    },
    //停用
    handleDisable(row) {
      if (!row) return;
      this.$confirm("确认停用该场馆吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          let para = { id: row.id, isDisable: true };
          disableRoomScreen(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.isSuccess) {
              this.$message({
                message: "已停用",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
            this.handleQuery();
          });
        })
        .catch(() => {});
    },
    //启用
    handleEnable(row) {
      if (!row) return;
      this.$confirm("确认启用该场馆吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          let para = { id: row.id, isDisable: false };
          disableRoomScreen(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.isSuccess) {
              this.$message({
                message: "已启用",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
            this.handleQuery();
          });
        })
        .catch(() => {});
    },
    //获取用户列表
    handleQuery() {
      this.listLoading = true;

      //NProgress.start();
      queryRoomScreenListPage(this.filter).then((res) => {
        this.pageModel = res.data.response;
        this.itemList = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.id };
          removeRoomScreen(para).then((res) => {
            this.listLoading = false;
            //NProgress.done();
            if (res.data.isSuccess) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit() {
      this.coverImageList = [];
      this.contentImageList = [];
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      if (row.coverImage) {
        this.coverImageList.push(row.coverImage);
      }
      if (row.contentImage) {
        this.contentImageList = row.contentImage;
      }
      this.editForm = {
        id: "",
        title: "",
        description: "",
        isDisable: false,
      };
      this.editForm = Object.assign({}, row);
      this.editFormVisible = true;
    },
    //显示新增界面
    handleAdd() {
      this.coverImageList = [];
      this.contentImageList = [];
      this.addFormVisible = true;
      this.addForm = {
        title: "",
        description: "",
        isDisable: false,
        mainColor: this.predefineMainColors[0]
      };
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            let formData = new FormData();
            this.editForm.coverImage = null;
            this.editForm.contentImage = null;
            formData.append("model", JSON.stringify(this.editForm));
            let covers = this.coverImageList.filter((s) => s.status == "ready");
            if (covers.length > 0) {
              formData.append("coverImage", covers[0].raw);
            }
            let contents = this.contentImageList.filter(
              (s) => s.status == "ready"
            );
            if (contents.length > 0) {
              contents.forEach((element) => {
                formData.append("contentImages", element.raw);
              });
            }
            saveRoomScreen(formData).then((res) => {
              this.editLoading = false;
              if (res.data.isSuccess) {
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.coverImageList = [];
                this.contentImageList = [];
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            let formData = new FormData();
            formData.append("model", JSON.stringify(this.addForm));
            let covers = this.coverImageList.filter((s) => s.status == "ready");
            if (covers.length > 0) {
              formData.append("coverImage", covers[0].raw);
            }
            let contents = this.contentImageList.filter(
              (s) => s.status == "ready"
            );
            if (contents.length > 0) {
              contents.forEach((element) => {
                formData.append("contentImages", element.raw);
              });
            }
            saveRoomScreen(formData).then((res) => {
              this.addLoading = false;
              if (res.data.isSuccess) {
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.coverImageList = [];
                this.contentImageList = [];
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.handleQuery();
    for(let c in ScreenColorTheme){
      this.predefineMainColors.push({
        key: c,
        value: ScreenColorTheme[c]
      });
    }
  },
  watch: {
    "editRoomScreenConfigForm.columns": {
      handler(val, oldVal) {
        if (this.roomScreenConfigTable.length > 0) {
          for (let r = 0; r < this.editRoomScreenConfigForm.rows; r++) {
            var row = this.editRoomScreenConfigForm[r];
            if (oldVal > val) {
              for (let c = oldVal - 1; c >= val - 1; c--) {
                if (row["col" + c]) {
                  delete row["col" + c];
                }
              }
            } else if (oldVal < val) {
              for (let c = oldVal - 1; c >= val - 1; c--) {
                if (!row["col" + c]) {
                  row["col" + c] = "";
                }
              }
            }
          }
        }
      },
      deep: true,
      immediate: true,
    },
    "editRoomScreenConfigForm.rows": {
      handler(val, oldVal) {
        if (this.roomScreenConfigTable.length < val) {
          while (this.roomScreenConfigTable.length < val) {
            var row = {};
            for (let c = 0; c < this.editRoomScreenConfigForm.columns; c++) {
              row["col" + c] = "";
            }
            this.roomScreenConfigTable.push(row);
          }
        } else {
          while (this.roomScreenConfigTable.length > val) {
            this.roomScreenConfigTable.pop();
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
.roomScreenConfigTable {
  width: 100%;
  padding: 0;
  background-color: #f3f3f3;
}
.roomScreenConfigTable /deep/ .el-table td,
.roomScreenConfigTable /deep/ .el-table th {
  padding: 2px !important;
}
</style>
